module.exports = __webpack_public_path__ + "static/media/20201001.dbdd6095.jpg";